module.exports = __webpack_public_path__ + "img/sainagreater.34a64629.svg";